/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { assignAuthSupportsToSubscription } from '../fn/subscriptions/assign-auth-supports-to-subscription';
import { AssignAuthSupportsToSubscription$Params } from '../fn/subscriptions/assign-auth-supports-to-subscription';
import { AuthSupport } from '../models/auth-support';
import { AuthSupportHistoryPagedList } from '../models/auth-support-history-paged-list';
import { AuthSupportPagedList } from '../models/auth-support-paged-list';
import { changeAuthSupportsState } from '../fn/authorization-supports/change-auth-supports-state';
import { ChangeAuthSupportsState$Params } from '../fn/authorization-supports/change-auth-supports-state';
import { changeSubscriptionAuthSupportsState } from '../fn/authorization-supports/change-subscription-auth-supports-state';
import { ChangeSubscriptionAuthSupportsState$Params } from '../fn/authorization-supports/change-subscription-auth-supports-state';
import { createAuthSupport } from '../fn/authorization-supports/create-auth-support';
import { CreateAuthSupport$Params } from '../fn/authorization-supports/create-auth-support';
import { createAuthSupportVehicle } from '../fn/authorization-supports/create-auth-support-vehicle';
import { CreateAuthSupportVehicle$Params } from '../fn/authorization-supports/create-auth-support-vehicle';
import { deleteAuthSupport } from '../fn/authorization-supports/delete-auth-support';
import { DeleteAuthSupport$Params } from '../fn/authorization-supports/delete-auth-support';
import { deleteAuthSupportVehicle } from '../fn/authorization-supports/delete-auth-support-vehicle';
import { DeleteAuthSupportVehicle$Params } from '../fn/authorization-supports/delete-auth-support-vehicle';
import { deletePlannedAuthSupportsTransferToSubscription } from '../fn/subscriptions/delete-planned-auth-supports-transfer-to-subscription';
import { DeletePlannedAuthSupportsTransferToSubscription$Params } from '../fn/subscriptions/delete-planned-auth-supports-transfer-to-subscription';
import { exportAuthSupports } from '../fn/authorization-supports/export-auth-supports';
import { ExportAuthSupports$Params } from '../fn/authorization-supports/export-auth-supports';
import { exportAuthSupportTransactions } from '../fn/transactions/export-auth-support-transactions';
import { ExportAuthSupportTransactions$Params } from '../fn/transactions/export-auth-support-transactions';
import { exportSubscriptionAuthSupports } from '../fn/subscriptions/export-subscription-auth-supports';
import { ExportSubscriptionAuthSupports$Params } from '../fn/subscriptions/export-subscription-auth-supports';
import { getAuthSupport } from '../fn/authorization-supports/get-auth-support';
import { GetAuthSupport$Params } from '../fn/authorization-supports/get-auth-support';
import { getAuthSupportChangesHistory } from '../fn/authorization-supports/get-auth-support-changes-history';
import { GetAuthSupportChangesHistory$Params } from '../fn/authorization-supports/get-auth-support-changes-history';
import { getAuthSupportProviders } from '../fn/authorization-supports/get-auth-support-providers';
import { GetAuthSupportProviders$Params } from '../fn/authorization-supports/get-auth-support-providers';
import { getAuthSupportVehicle } from '../fn/authorization-supports/get-auth-support-vehicle';
import { GetAuthSupportVehicle$Params } from '../fn/authorization-supports/get-auth-support-vehicle';
import { getPlannedAuthSupportsTransfersToSubscription } from '../fn/subscriptions/get-planned-auth-supports-transfers-to-subscription';
import { GetPlannedAuthSupportsTransfersToSubscription$Params } from '../fn/subscriptions/get-planned-auth-supports-transfers-to-subscription';
import { getSubscriptionsAuthSupportStats } from '../fn/subscriptions/get-subscriptions-auth-support-stats';
import { GetSubscriptionsAuthSupportStats$Params } from '../fn/subscriptions/get-subscriptions-auth-support-stats';
import { getTransactionsOfAuthSupport } from '../fn/transactions/get-transactions-of-auth-support';
import { GetTransactionsOfAuthSupport$Params } from '../fn/transactions/get-transactions-of-auth-support';
import { importAuthSupport } from '../fn/authorization-supports/import-auth-support';
import { ImportAuthSupport$Params } from '../fn/authorization-supports/import-auth-support';
import { PlannedAuthSupportsTransferList } from '../models/planned-auth-supports-transfer-list';
import { removeAuthSupportsFromSubscription } from '../fn/subscriptions/remove-auth-supports-from-subscription';
import { RemoveAuthSupportsFromSubscription$Params } from '../fn/subscriptions/remove-auth-supports-from-subscription';
import { searchAuthSupportsList$Any } from '../fn/authorization-supports/search-auth-supports-list-any';
import { SearchAuthSupportsList$Any$Params } from '../fn/authorization-supports/search-auth-supports-list-any';
import { searchAuthSupportsList$Json } from '../fn/authorization-supports/search-auth-supports-list-json';
import { SearchAuthSupportsList$Json$Params } from '../fn/authorization-supports/search-auth-supports-list-json';
import { searchAuthSupportsOfSubscription$Any } from '../fn/subscriptions/search-auth-supports-of-subscription-any';
import { SearchAuthSupportsOfSubscription$Any$Params } from '../fn/subscriptions/search-auth-supports-of-subscription-any';
import { searchAuthSupportsOfSubscription$Json } from '../fn/subscriptions/search-auth-supports-of-subscription-json';
import { SearchAuthSupportsOfSubscription$Json$Params } from '../fn/subscriptions/search-auth-supports-of-subscription-json';
import { searchTransactionsOfAuthSupports$Any } from '../fn/transactions/search-transactions-of-auth-supports-any';
import { SearchTransactionsOfAuthSupports$Any$Params } from '../fn/transactions/search-transactions-of-auth-supports-any';
import { searchTransactionsOfAuthSupports$Json } from '../fn/transactions/search-transactions-of-auth-supports-json';
import { SearchTransactionsOfAuthSupports$Json$Params } from '../fn/transactions/search-transactions-of-auth-supports-json';
import { SubscriptionAuthSupportStats } from '../models/subscription-auth-support-stats';
import { TransactionPagedList } from '../models/transaction-paged-list';
import { transferAuthSupportsToSubscription } from '../fn/subscriptions/transfer-auth-supports-to-subscription';
import { TransferAuthSupportsToSubscription$Params } from '../fn/subscriptions/transfer-auth-supports-to-subscription';
import { updateAuthSupport } from '../fn/authorization-supports/update-auth-support';
import { UpdateAuthSupport$Params } from '../fn/authorization-supports/update-auth-support';
import { updateAuthSupportVehicle } from '../fn/authorization-supports/update-auth-support-vehicle';
import { UpdateAuthSupportVehicle$Params } from '../fn/authorization-supports/update-auth-support-vehicle';
import { updateSubscriptionAuthSupport } from '../fn/authorization-supports/update-subscription-auth-support';
import { UpdateSubscriptionAuthSupport$Params } from '../fn/authorization-supports/update-subscription-auth-support';
import { userAddAuthSupports } from '../fn/subscriptions/user-add-auth-supports';
import { UserAddAuthSupports$Params } from '../fn/subscriptions/user-add-auth-supports';
import { userRemoveAuthSupports } from '../fn/subscriptions/user-remove-auth-supports';
import { UserRemoveAuthSupports$Params } from '../fn/subscriptions/user-remove-auth-supports';
import { Vehicle } from '../models/vehicle';
import { vehicleAddAuthSupport } from '../fn/subscriptions/vehicle-add-auth-support';
import { VehicleAddAuthSupport$Params } from '../fn/subscriptions/vehicle-add-auth-support';
import { vehicleRemoveAuthSupport } from '../fn/subscriptions/vehicle-remove-auth-support';
import { VehicleRemoveAuthSupport$Params } from '../fn/subscriptions/vehicle-remove-auth-support';


/**
 * All about the authorization supports (badges, license plates..)
 */
@Injectable({ providedIn: 'root' })
export class AuthorizationSupportsService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSubscriptionsAuthSupportStats()` */
  static readonly GetSubscriptionsAuthSupportStatsPath = '/subscriptions/auth-supports/stats';

  /**
   * Get stats about subscriptions auth support.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionsAuthSupportStats()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSubscriptionsAuthSupportStats$Response(params: GetSubscriptionsAuthSupportStats$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubscriptionAuthSupportStats>>> {
    return getSubscriptionsAuthSupportStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Get stats about subscriptions auth support.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionsAuthSupportStats$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSubscriptionsAuthSupportStats(params: GetSubscriptionsAuthSupportStats$Params, context?: HttpContext): Observable<Array<SubscriptionAuthSupportStats>> {
    return this.getSubscriptionsAuthSupportStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubscriptionAuthSupportStats>>): Array<SubscriptionAuthSupportStats> => r.body)
    );
  }

  /** Path part for operation `searchAuthSupportsOfSubscription()` */
  static readonly SearchAuthSupportsOfSubscriptionPath = '/subscriptions/{uid}/auth-supports/search';

  /**
   * List the auth supports of a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAuthSupportsOfSubscription$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAuthSupportsOfSubscription$Json$Response(params: SearchAuthSupportsOfSubscription$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportPagedList>> {
    return searchAuthSupportsOfSubscription$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * List the auth supports of a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAuthSupportsOfSubscription$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAuthSupportsOfSubscription$Json(params: SearchAuthSupportsOfSubscription$Json$Params, context?: HttpContext): Observable<AuthSupportPagedList> {
    return this.searchAuthSupportsOfSubscription$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportPagedList>): AuthSupportPagedList => r.body)
    );
  }

  /**
   * List the auth supports of a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAuthSupportsOfSubscription$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchAuthSupportsOfSubscription$Any$Response(params: SearchAuthSupportsOfSubscription$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportPagedList>> {
    return searchAuthSupportsOfSubscription$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * List the auth supports of a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAuthSupportsOfSubscription$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchAuthSupportsOfSubscription$Any(params: SearchAuthSupportsOfSubscription$Any$Params, context?: HttpContext): Observable<AuthSupportPagedList> {
    return this.searchAuthSupportsOfSubscription$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportPagedList>): AuthSupportPagedList => r.body)
    );
  }

  /** Path part for operation `exportSubscriptionAuthSupports()` */
  static readonly ExportSubscriptionAuthSupportsPath = '/subscriptions/{uid}/auth-supports/export';

  /**
   * Export  the auth supports assigned to this subscription.
   *
   * Allows to export the Subscription auth supports
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSubscriptionAuthSupports()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionAuthSupports$Response(params: ExportSubscriptionAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSubscriptionAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Export  the auth supports assigned to this subscription.
   *
   * Allows to export the Subscription auth supports
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSubscriptionAuthSupports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionAuthSupports(params: ExportSubscriptionAuthSupports$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSubscriptionAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `assignAuthSupportsToSubscription()` */
  static readonly AssignAuthSupportsToSubscriptionPath = '/subscriptions/{uid}/auth-supports/assign';

  /**
   * Add auth supports to a subscription, if the supports are already assigned to a subscription, they will be ignored.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignAuthSupportsToSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignAuthSupportsToSubscription$Response(params: AssignAuthSupportsToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assignAuthSupportsToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Add auth supports to a subscription, if the supports are already assigned to a subscription, they will be ignored.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignAuthSupportsToSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignAuthSupportsToSubscription(params: AssignAuthSupportsToSubscription$Params, context?: HttpContext): Observable<void> {
    return this.assignAuthSupportsToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeAuthSupportsFromSubscription()` */
  static readonly RemoveAuthSupportsFromSubscriptionPath = '/subscriptions/{uid}/auth-supports/remove';

  /**
   * Remove auth supports from a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeAuthSupportsFromSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeAuthSupportsFromSubscription$Response(params: RemoveAuthSupportsFromSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeAuthSupportsFromSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove auth supports from a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeAuthSupportsFromSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeAuthSupportsFromSubscription(params: RemoveAuthSupportsFromSubscription$Params, context?: HttpContext): Observable<void> {
    return this.removeAuthSupportsFromSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `transferAuthSupportsToSubscription()` */
  static readonly TransferAuthSupportsToSubscriptionPath = '/subscriptions/{uid}/auth-supports/transfer';

  /**
   * Transfer auth supports to a subscription. Contrary to the 'assign' endpoint, already assigned supports will be removed from any link they have to be assigned to the new subscription. So use this endpoint with caution.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transferAuthSupportsToSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transferAuthSupportsToSubscription$Response(params: TransferAuthSupportsToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return transferAuthSupportsToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Transfer auth supports to a subscription. Contrary to the 'assign' endpoint, already assigned supports will be removed from any link they have to be assigned to the new subscription. So use this endpoint with caution.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transferAuthSupportsToSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transferAuthSupportsToSubscription(params: TransferAuthSupportsToSubscription$Params, context?: HttpContext): Observable<void> {
    return this.transferAuthSupportsToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getPlannedAuthSupportsTransfersToSubscription()` */
  static readonly GetPlannedAuthSupportsTransfersToSubscriptionPath = '/subscriptions/{uid}/auth-supports/transfer/planned';

  /**
   * Get the planned transfers of auth-supports to the subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPlannedAuthSupportsTransfersToSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlannedAuthSupportsTransfersToSubscription$Response(params: GetPlannedAuthSupportsTransfersToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedAuthSupportsTransferList>> {
    return getPlannedAuthSupportsTransfersToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the planned transfers of auth-supports to the subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPlannedAuthSupportsTransfersToSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlannedAuthSupportsTransfersToSubscription(params: GetPlannedAuthSupportsTransfersToSubscription$Params, context?: HttpContext): Observable<PlannedAuthSupportsTransferList> {
    return this.getPlannedAuthSupportsTransfersToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlannedAuthSupportsTransferList>): PlannedAuthSupportsTransferList => r.body)
    );
  }

  /** Path part for operation `deletePlannedAuthSupportsTransferToSubscription()` */
  static readonly DeletePlannedAuthSupportsTransferToSubscriptionPath = '/subscriptions/{uid}/auth-supports/transfer/planned/{transferUid}';

  /**
   * Delete a planned transfer of auth-supports to the subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePlannedAuthSupportsTransferToSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePlannedAuthSupportsTransferToSubscription$Response(params: DeletePlannedAuthSupportsTransferToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deletePlannedAuthSupportsTransferToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a planned transfer of auth-supports to the subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePlannedAuthSupportsTransferToSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePlannedAuthSupportsTransferToSubscription(params: DeletePlannedAuthSupportsTransferToSubscription$Params, context?: HttpContext): Observable<void> {
    return this.deletePlannedAuthSupportsTransferToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userAddAuthSupports()` */
  static readonly UserAddAuthSupportsPath = '/subscriptions/{uid}/users/{userUid}/auth-supports/assign';

  /**
   * Add auth supports to a subscription and user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAddAuthSupports()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAddAuthSupports$Response(params: UserAddAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userAddAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Add auth supports to a subscription and user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAddAuthSupports$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAddAuthSupports(params: UserAddAuthSupports$Params, context?: HttpContext): Observable<void> {
    return this.userAddAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userRemoveAuthSupports()` */
  static readonly UserRemoveAuthSupportsPath = '/subscriptions/{uid}/users/{userUid}/auth-supports/remove';

  /**
   * Remove auth supports from a subscription and user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRemoveAuthSupports()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRemoveAuthSupports$Response(params: UserRemoveAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userRemoveAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove auth supports from a subscription and user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRemoveAuthSupports$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRemoveAuthSupports(params: UserRemoveAuthSupports$Params, context?: HttpContext): Observable<void> {
    return this.userRemoveAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `vehicleAddAuthSupport()` */
  static readonly VehicleAddAuthSupportPath = '/subscriptions/{uid}/vehicles/{vehicleUid}/auth-supports/assign';

  /**
   * Add a auth support to a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vehicleAddAuthSupport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleAddAuthSupport$Response(params: VehicleAddAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return vehicleAddAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a auth support to a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vehicleAddAuthSupport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleAddAuthSupport(params: VehicleAddAuthSupport$Params, context?: HttpContext): Observable<void> {
    return this.vehicleAddAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `vehicleRemoveAuthSupport()` */
  static readonly VehicleRemoveAuthSupportPath = '/subscriptions/{uid}/vehicles/{vehicleUid}/auth-supports/remove';

  /**
   * Remove a auth support from a subscription and vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vehicleRemoveAuthSupport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleRemoveAuthSupport$Response(params: VehicleRemoveAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return vehicleRemoveAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove a auth support from a subscription and vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vehicleRemoveAuthSupport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleRemoveAuthSupport(params: VehicleRemoveAuthSupport$Params, context?: HttpContext): Observable<void> {
    return this.vehicleRemoveAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTransactionsOfAuthSupport()` */
  static readonly GetTransactionsOfAuthSupportPath = '/auth-supports/{uid}/transactions';

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransactionsOfAuthSupport()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getTransactionsOfAuthSupport$Response(params: GetTransactionsOfAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return getTransactionsOfAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransactionsOfAuthSupport$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getTransactionsOfAuthSupport(params: GetTransactionsOfAuthSupport$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.getTransactionsOfAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `searchTransactionsOfAuthSupports()` */
  static readonly SearchTransactionsOfAuthSupportsPath = '/auth-supports/{uid}/transactions/search';

  /**
   * Search the transactions of an auth-support with filters, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactionsOfAuthSupports$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactionsOfAuthSupports$Json$Response(params: SearchTransactionsOfAuthSupports$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return searchTransactionsOfAuthSupports$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the transactions of an auth-support with filters, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactionsOfAuthSupports$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactionsOfAuthSupports$Json(params: SearchTransactionsOfAuthSupports$Json$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.searchTransactionsOfAuthSupports$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /**
   * Search the transactions of an auth-support with filters, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactionsOfAuthSupports$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTransactionsOfAuthSupports$Any$Response(params: SearchTransactionsOfAuthSupports$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return searchTransactionsOfAuthSupports$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the transactions of an auth-support with filters, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactionsOfAuthSupports$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTransactionsOfAuthSupports$Any(params: SearchTransactionsOfAuthSupports$Any$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.searchTransactionsOfAuthSupports$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `exportAuthSupportTransactions()` */
  static readonly ExportAuthSupportTransactionsPath = '/auth-supports/{uid}/transactions/export';

  /**
   * Export the transactions assigned to this auth support.
   *
   * Allows to export the auth support transactions as an XLSX File
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportAuthSupportTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportAuthSupportTransactions$Response(params: ExportAuthSupportTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportAuthSupportTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the transactions assigned to this auth support.
   *
   * Allows to export the auth support transactions as an XLSX File
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportAuthSupportTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportAuthSupportTransactions(params: ExportAuthSupportTransactions$Params, context?: HttpContext): Observable<Blob> {
    return this.exportAuthSupportTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `searchAuthSupportsList()` */
  static readonly SearchAuthSupportsListPath = '/auth-supports/search';

  /**
   * search auth supports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAuthSupportsList$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAuthSupportsList$Json$Response(params?: SearchAuthSupportsList$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportPagedList>> {
    return searchAuthSupportsList$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * search auth supports.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAuthSupportsList$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAuthSupportsList$Json(params?: SearchAuthSupportsList$Json$Params, context?: HttpContext): Observable<AuthSupportPagedList> {
    return this.searchAuthSupportsList$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportPagedList>): AuthSupportPagedList => r.body)
    );
  }

  /**
   * search auth supports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAuthSupportsList$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchAuthSupportsList$Any$Response(params?: SearchAuthSupportsList$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportPagedList>> {
    return searchAuthSupportsList$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * search auth supports.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAuthSupportsList$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchAuthSupportsList$Any(params?: SearchAuthSupportsList$Any$Params, context?: HttpContext): Observable<AuthSupportPagedList> {
    return this.searchAuthSupportsList$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportPagedList>): AuthSupportPagedList => r.body)
    );
  }

  /** Path part for operation `getAuthSupportProviders()` */
  static readonly GetAuthSupportProvidersPath = '/auth-supports-providers';

  /**
   * Retrieve the list of available providers for auth supports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuthSupportProviders()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportProviders$Response(params?: GetAuthSupportProviders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getAuthSupportProviders(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve the list of available providers for auth supports.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuthSupportProviders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportProviders(params?: GetAuthSupportProviders$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getAuthSupportProviders$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `createAuthSupport()` */
  static readonly CreateAuthSupportPath = '/auth-supports';

  /**
   * Create a auth support.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAuthSupport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAuthSupport$Response(params: CreateAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a auth support.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAuthSupport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAuthSupport(params: CreateAuthSupport$Params, context?: HttpContext): Observable<void> {
    return this.createAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `changeSubscriptionAuthSupportsState()` */
  static readonly ChangeSubscriptionAuthSupportsStatePath = '/subscriptions/{uid}/auth-supports/{authSupportUid}/state';

  /**
   * Change the state of a subscription Auth Supports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeSubscriptionAuthSupportsState()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeSubscriptionAuthSupportsState$Response(params: ChangeSubscriptionAuthSupportsState$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changeSubscriptionAuthSupportsState(this.http, this.rootUrl, params, context);
  }

  /**
   * Change the state of a subscription Auth Supports.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeSubscriptionAuthSupportsState$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeSubscriptionAuthSupportsState(params: ChangeSubscriptionAuthSupportsState$Params, context?: HttpContext): Observable<void> {
    return this.changeSubscriptionAuthSupportsState$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateSubscriptionAuthSupport()` */
  static readonly UpdateSubscriptionAuthSupportPath = '/subscriptions/{uid}/auth-supports/{authSupportUid}';

  /**
   * Update a subscription auth support.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubscriptionAuthSupport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionAuthSupport$Response(params: UpdateSubscriptionAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSubscriptionAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a subscription auth support.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubscriptionAuthSupport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionAuthSupport(params: UpdateSubscriptionAuthSupport$Params, context?: HttpContext): Observable<void> {
    return this.updateSubscriptionAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAuthSupport()` */
  static readonly GetAuthSupportPath = '/auth-supports/{uid}';

  /**
   * get a auth support.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuthSupport()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupport$Response(params: GetAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupport>> {
    return getAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * get a auth support.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuthSupport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupport(params: GetAuthSupport$Params, context?: HttpContext): Observable<AuthSupport> {
    return this.getAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupport>): AuthSupport => r.body)
    );
  }

  /** Path part for operation `updateAuthSupport()` */
  static readonly UpdateAuthSupportPath = '/auth-supports/{uid}';

  /**
   * Update a auth support.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAuthSupport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAuthSupport$Response(params: UpdateAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a auth support.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAuthSupport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAuthSupport(params: UpdateAuthSupport$Params, context?: HttpContext): Observable<void> {
    return this.updateAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteAuthSupport()` */
  static readonly DeleteAuthSupportPath = '/auth-supports/{uid}';

  /**
   * Delete a auth support.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAuthSupport()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthSupport$Response(params: DeleteAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a auth support.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAuthSupport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthSupport(params: DeleteAuthSupport$Params, context?: HttpContext): Observable<void> {
    return this.deleteAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAuthSupportVehicle()` */
  static readonly GetAuthSupportVehiclePath = '/auth-supports/{uid}/vehicle';

  /**
   * get a auth support associated vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuthSupportVehicle()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportVehicle$Response(params: GetAuthSupportVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<Vehicle>> {
    return getAuthSupportVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * get a auth support associated vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuthSupportVehicle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportVehicle(params: GetAuthSupportVehicle$Params, context?: HttpContext): Observable<Vehicle> {
    return this.getAuthSupportVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<Vehicle>): Vehicle => r.body)
    );
  }

  /** Path part for operation `updateAuthSupportVehicle()` */
  static readonly UpdateAuthSupportVehiclePath = '/auth-supports/{uid}/vehicle';

  /**
   * Update a auth support associated vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAuthSupportVehicle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAuthSupportVehicle$Response(params: UpdateAuthSupportVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateAuthSupportVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a auth support associated vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAuthSupportVehicle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAuthSupportVehicle(params: UpdateAuthSupportVehicle$Params, context?: HttpContext): Observable<void> {
    return this.updateAuthSupportVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createAuthSupportVehicle()` */
  static readonly CreateAuthSupportVehiclePath = '/auth-supports/{uid}/vehicle';

  /**
   * Create a auth support associated vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAuthSupportVehicle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAuthSupportVehicle$Response(params: CreateAuthSupportVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createAuthSupportVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a auth support associated vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAuthSupportVehicle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAuthSupportVehicle(params: CreateAuthSupportVehicle$Params, context?: HttpContext): Observable<void> {
    return this.createAuthSupportVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteAuthSupportVehicle()` */
  static readonly DeleteAuthSupportVehiclePath = '/auth-supports/{uid}/vehicle';

  /**
   * Delete a auth support associated vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAuthSupportVehicle()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthSupportVehicle$Response(params: DeleteAuthSupportVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAuthSupportVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a auth support associated vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAuthSupportVehicle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthSupportVehicle(params: DeleteAuthSupportVehicle$Params, context?: HttpContext): Observable<void> {
    return this.deleteAuthSupportVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAuthSupportChangesHistory()` */
  static readonly GetAuthSupportChangesHistoryPath = '/auth-supports/{uid}/history';

  /**
   * Retrieve a list of change made to an auth support, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuthSupportChangesHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportChangesHistory$Response(params: GetAuthSupportChangesHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportHistoryPagedList>> {
    return getAuthSupportChangesHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of change made to an auth support, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuthSupportChangesHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportChangesHistory(params: GetAuthSupportChangesHistory$Params, context?: HttpContext): Observable<AuthSupportHistoryPagedList> {
    return this.getAuthSupportChangesHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportHistoryPagedList>): AuthSupportHistoryPagedList => r.body)
    );
  }

  /** Path part for operation `importAuthSupport()` */
  static readonly ImportAuthSupportPath = '/auth-supports/import';

  /**
   * Import the the AuthSupports.
   *
   * Allows to import the AuthSupports, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importAuthSupport()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importAuthSupport$Response(params?: ImportAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the the AuthSupports.
   *
   * Allows to import the AuthSupports, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importAuthSupport$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importAuthSupport(params?: ImportAuthSupport$Params, context?: HttpContext): Observable<void> {
    return this.importAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportAuthSupports()` */
  static readonly ExportAuthSupportsPath = '/auth-supports/export';

  /**
   * Export the AuthSupports.
   *
   * Allows to export the the AuthSupports.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportAuthSupports()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportAuthSupports$Response(params?: ExportAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the AuthSupports.
   *
   * Allows to export the the AuthSupports.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportAuthSupports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportAuthSupports(params?: ExportAuthSupports$Params, context?: HttpContext): Observable<Blob> {
    return this.exportAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `changeAuthSupportsState()` */
  static readonly ChangeAuthSupportsStatePath = '/auth-supports/state';

  /**
   * Change the state of a list of Auth Supports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeAuthSupportsState()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeAuthSupportsState$Response(params: ChangeAuthSupportsState$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changeAuthSupportsState(this.http, this.rootUrl, params, context);
  }

  /**
   * Change the state of a list of Auth Supports.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeAuthSupportsState$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeAuthSupportsState(params: ChangeAuthSupportsState$Params, context?: HttpContext): Observable<void> {
    return this.changeAuthSupportsState$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
